import type { AuditTone } from 'utils/auditLabels';

/** Tone → Tailwind classes (light + dark), shared by `ActionPill` and `AuditChanges`' `Pill` (I4). */
export const TONE_CLASSES: Record<AuditTone, string> = {
  violet: 'bg-violet-50 text-violet-700 dark:bg-violet-950 dark:text-violet-400',
  sky: 'bg-sky-50 text-sky-700 dark:bg-sky-950 dark:text-sky-400',
  rose: 'bg-rose-50 text-rose-700 dark:bg-rose-950 dark:text-rose-400',
  emerald: 'bg-emerald-50 text-emerald-700 dark:bg-emerald-950 dark:text-emerald-400',
  amber: 'bg-amber-50 text-amber-700 dark:bg-amber-950 dark:text-amber-400',
  zinc: 'bg-zinc-100 text-zinc-600 dark:bg-zinc-800 dark:text-zinc-300',
};
